export const URLParamToArray = (urlParam: string) => {
    if (urlParam.includes("&")) {
        let strArray = urlParam.split("&");
        let params: string[] = [];
        strArray.forEach((id) => {
            let idShort = id.slice(5, 8) + " " + id.slice(8, 10) + " " + id.slice(10);
            params.push(idShort);
        })
        return params;
    } else {
        let id = urlParam.slice(5, 8) + " " + urlParam.slice(8, 10) + " " + urlParam.slice(10);
        return ([id]);
    }
}